module.exports = __webpack_public_path__ + "img/argentina.533de5f8.svg";